/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandComedyCentral = createReactComponent(
  "brand-comedy-central",
  "IconBrandComedyCentral",
  [
    ["path", { d: "M5.343 17.657a8 8 0 1 0 0 -11.314", key: "svg-0" }],
    ["path", { d: "M13.828 9.172a4 4 0 1 0 0 5.656", key: "svg-1" }]
  ]
);

export { IconBrandComedyCentral as default };
//# sourceMappingURL=IconBrandComedyCentral.js.map
